import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UserRole } from "../../../enum";
import controlService from "../../../services/controlService";
import { useAppSelector } from "../../../storeHooks";
import { Pagination } from "../../Pagination/Pagination";
import { DroneListItem } from "../DroneListItem/DroneListItem";
export const DroneList = ({ dronesListData, onDelete, onAdd, inUse, online, showControls, handlePageChangeDrones, currentPage, totalPages, }) => {
    const { t } = useTranslation();
    const [isShowModalToDelete, setShowModalToDelete] = useState(false);
    const [droneAction, setDroneAction] = useState(null);
    const currUser = useAppSelector((store) => store.user.value);
    const navigate = useNavigate();
    const [showAlertModal, setShowAlertModal] = useState(false);
    const [passwordIncorrect, setPasswordIncorrect] = useState(false);
    const { register, handleSubmit, formState: { errors }, } = useForm({
        defaultValues: {
            password: "",
        },
    });
    const connect = (droneId) => {
        controlService
            .canControlDrone(droneId)
            .then((res) => {
            console.log(res);
            if (res) {
                navigate(`/dashboard/control/${droneId}`);
            }
            else {
                setDroneAction({ id: droneId, name: "" });
                setShowAlertModal(true);
            }
        })
            .catch();
    };
    const confirm = (data) => {
        if (droneAction) {
            controlService
                .getControlToken(data.password)
                .then((data) => {
                if (data.token) {
                    setShowAlertModal(false);
                    setPasswordIncorrect(false);
                    navigate(`/dashboard/control/${droneAction.id}`, {
                        state: { token: data.token },
                    });
                }
                else {
                    setPasswordIncorrect(true);
                }
            })
                .catch();
        }
    };
    const closeAlertModal = () => {
        setShowAlertModal(false);
        setDroneAction(null);
    };
    const deleteDroneFromList = (droneId, droneName) => {
        setDroneAction({ id: droneId, name: droneName });
        setShowModalToDelete(true);
    };
    const confirmDelete = (droneId) => {
        if (onDelete) {
            onDelete(droneId);
        }
        setShowModalToDelete(false);
    };
    const closeModal = () => {
        setShowModalToDelete(false);
    };
    return (_jsxs("div", { className: "drone-list-wrapper", children: [dronesListData.map((item) => (_jsx(DroneListItem, { droneData: item, onAdd: onAdd, onDelete: onDelete ? deleteDroneFromList : undefined, onConnect: connect, showControls: showControls, isDroneUse: inUse ? inUse[item.id] : false, isDroneOnline: online ? online[item.id] : false }, item.id))), _jsx(Pagination, { currentPage: currentPage, totalPages: totalPages, onPageChange: handlePageChangeDrones }), isShowModalToDelete && droneAction ? (_jsx("div", { className: "modal-wrapper", children: _jsxs("dialog", { open: true, onCancel: closeModal, children: [_jsx("h4", { children: t("droneList.deleteModal.title", { name: droneAction.name }) }), _jsxs("div", { className: "text-center", children: [_jsx("button", { className: "btn btn-primary", onClick: () => confirmDelete(droneAction.id), children: t("droneList.deleteModal.confirm") }), _jsx("button", { className: "btn btn-secondary", onClick: closeModal, children: t("droneList.deleteModal.close") })] })] }) })) : null, showAlertModal && droneAction ? (_jsx("div", { className: "modal-wrapper", children: currUser.role === UserRole.Operator ? (_jsxs("dialog", { open: true, onCancel: closeAlertModal, children: [_jsx("h4", { children: t("droneList.alertOperator.message") }), _jsx("div", { className: "text-center", children: _jsx("button", { className: "btn btn-secondary", onClick: closeAlertModal, children: t("droneList.alertOperator.close") }) })] })) : (_jsxs("dialog", { open: true, onCancel: closeAlertModal, children: [_jsx("h4", { children: t("droneList.alertOther.message1") }), _jsx("h4", { children: t("droneList.alertOther.message2") }), _jsx("h4", { children: t("droneList.alertOther.message3") }), _jsxs("form", { onSubmit: handleSubmit((data) => confirm(data)), children: [_jsxs("div", { children: [_jsx("label", { children: t("droneList.alertOther.passwordLabel") }), _jsx("input", Object.assign({ type: "password" }, register("password", { required: true }))), errors.password && (_jsx("span", { className: "error", children: t("droneList.alertOther.requiredError") })), passwordIncorrect && (_jsx("span", { className: "error", children: t("droneList.alertOther.incorrectError") }))] }), _jsxs("div", { className: "text-center", children: [_jsx("button", { type: "submit", className: "btn btn-primary", children: t("droneList.alertOther.submit") }), _jsx("button", { className: "btn btn-secondary", onClick: closeAlertModal, children: t("droneList.alertOther.close") })] })] })] })) })) : null] }));
};
